import React, { useState, useEffect, useRef } from "react";
import translate from '../locales/commitments';
import Img from '../components/image';



function Commitments() {

    const commitments = [

        {

            title: translate.chosing.title,
            content: translate.chosing.content,
            button: translate.chosing.button,
            link: translate.chosing.link,
            more: translate.chosing.more



        },
        {

            title: translate.forall.title,
            content: translate.forall.content,
            button: translate.forall.button,
            link: translate.forall.link,
            more: translate.forall.more,
            alt: translate.forall.alt,
            legend: translate.forall.legend

        },
        {

            title: translate.workplace.title,
            content: translate.workplace.content,
            button: translate.workplace.button,
            link: translate.workplace.link,
            secondaryButton: translate.workplace.secondaryButton,
            secondaryLink: translate.workplace.secondaryLink,
            more: translate.workplace.more,
            alt: translate.workplace.alt,
            legend: translate.workplace.legend


        },
        {

            title: translate.communities.title,
            content: translate.communities.content,
            button: translate.communities.button,
            link: translate.communities.link,
            more: translate.communities.more


        },
        {

            title: translate.communications.title,
            content: translate.communications.content,
            button: translate.communications.button,
            link: translate.communications.link,
            more: translate.communications.more


        },



    ];


    const [isOpen, setIsOpen] = useState(false);
    const [contentReady, setContentReady] = useState(false);

    const [commitment, setCommitment] = useState("");

    const node = useRef();

    const openMessage = () => {
        setIsOpen(true);
        setContentReady(true);
        document.getElementsByClassName('outerMessage')[0].classList.add('backdrop');
        document.getElementsByTagName('body')[0].style.overflow = 'hidden'

    }
    const closeMessage = () => {
        setIsOpen(false);
        setContentReady(false);
        document.getElementsByClassName('outerMessage')[0].classList.remove('backdrop');
        document.getElementsByTagName('body')[0].style.overflow = 'scroll'



    }



    const handleBlur = e => {
        if (node.current.contains(e.target)) {
            // inside click  

            document.getElementsByClassName('outerMessage')[0].classList.add('backdrop');

            return;
        }
        // outside click 
        else {


            closeMessage();

        }
    };

    useEffect(() => {
        // add when mounted
        document.addEventListener("mousedown", handleBlur);

        // return function to be called when unmounted
        return () => {
            document.removeEventListener("mousedown", handleBlur);
        };


    });



    return (
        <div className="commitments">
            <div className="large container medium-padding-vertical">
                <h2 className="purple">{translate.title}</h2>
                <div className="blur">
                    {commitments.map((commitment, index) => (
                        <div className="commitment" key={commitment.title}>
                            <div className="commitment-number purple">
                                {index + 1}
                                <hr className="thick pink" />
                            </div>
                            <div className={commitment.image ? "commitmentImageCont" : null}>
                                <h3 className="purple">{commitment.title}</h3>
                                <p>{commitment.content}</p>
                                <div className={commitment.secondaryLink ? "flex" : ''}>
                                    {commitment.secondaryLink ? <a className="button" href="/" onClick={e => {
                                        let hero = document.getElementById('stats');
                                        console.log(hero);
                                        e.preventDefault();  // Stop Page Reloading
                                        hero && hero.scrollIntoView({ behavior: 'smooth' });
                                    }}>{commitment.secondaryButton}</a> : ''}
                                    <button className="button" onClick={() => { openMessage(); setCommitment(commitment.more) }}>{commitment.button}</button></div>
                            </div>
                            {commitment.image ? <Img lazySrc="https://site-cbc.radio-canada.ca/site/edi/gem-load-grise.gif" src={commitment.image} alt={commitment.alt} legend={commitment.legend} />
                                : null}
                        </div>
                    ))}



                </div>
                <div className="outerMessage">
                    <div ref={node} className={isOpen ? "message open" : "message"}>
                        {contentReady ? <><button aria-label={translate.read} onClick={closeMessage} className="eMedium medium uppercase bt-noir">{isOpen ? 'X' : ''}</button><div className="innerMessage" onBlur={handleBlur}>

                            <div className="moreInfoContainer" id="moreInfoContainer">
                                <div className="video">

                                    <p className="black medium">{commitment}</p>


                                </div>
                            </div>

                        </div></>
                            : ''}
                    </div></div>
            </div>
        </div>
    )
}

export default Commitments;